import axios from "axios";
import { TAG_URL } from "../../../../../constants/config";

// CREATE =>  POST: add a new tag to the server
export function createTag(tag) {
  var tagJson = JSON.stringify(tag);
  return axios.post(TAG_URL, tag);
}

// READ
export function getAllTags() {
  return axios.get(`${TAG_URL}/list`);
}

export function getTagById(tagId) {
  return axios.get(`${TAG_URL}/${tagId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findTags(queryParams) {
  return axios.get(`${TAG_URL}/list?search_key=${queryParams ? queryParams : ""}`);
}

// UPDATE => PUT: update the procuct on the server
export function updateTag(tag) {
  return axios.put(`${TAG_URL}/${tag.id}`, { tag });
}

// UPDATE Status
export function updateStatusForTags(ids, status) {
  return axios.post(`${TAG_URL}/updateStatusForTags`, {
    ids,
    status,
  });
}

// DELETE => delete the tag from the server
export function deleteTag(tagId) {
  return axios.delete(`${TAG_URL}/${tagId}`);
}

// DELETE Tags by ids
export function deleteTags(ids) {
  return axios.post(`${TAG_URL}/deleteTags`, { ids });
}


// Tags V2

export function getAllTagsV2(queryParams) {
  return axios.get(`${TAG_URL}/list?search_key=${queryParams?.searchKey || ""}&tag_type=${queryParams?.tag_type || ""}&status=${queryParams?.tag_status || "" }&page=${queryParams?.pageNumber || 1}&page_size=${queryParams?.pageSize || 20}`);
}

export const getTagsOptimize = async (params) => {
  return axios.get(`${TAG_URL}/list`, { params });
}

export function createTags(payload) {
  return axios.post(`${TAG_URL}/v2`,payload);
}

export function deleteTagV2(tagId) {
  return axios.delete(`${TAG_URL}/v2/${tagId}`);
}

export function updateTagV2(id,tag) {
  return axios.put(`${TAG_URL}/v2/${id}`, tag );
}

export function getTagByIdV2(tagId) {
  return axios.get(`${TAG_URL}/v2/${tagId}`);
}
